import View from './View';

export { default as View, getDropdownButtonStyle } from './View';

export default View;
